<template>
    <div class="progress-bar-component">
        <progress class="bar" :value="normalizeValue" :max="max">{{ normalizeValue }}%</progress>
        <span>{{ normalizeValue }}%</span>
    </div>
</template>
<script>
export default {
    name: 'ProgressBar',
    data() {
        return {
            value: 0,
        }
    },
    props: {
        modelValue: {
            type: Number,
            default: 0,
        },
        color:{
            type: String,
            default: "#004EFF"
        },
        max: {
            type: Number,
            default: 100
        },
        min: {
            type: Number,
            default: 0
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(value) {
                this.value = value
            },
        },
    },
    computed:{
        normalizeValue(){
            return Math.round(this.value)
        }
    }
}
</script>
<style lang="scss" scoped>
.progress-bar-component {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    progress {
        flex: 1 0 0;
    }
}
</style>